<template>
  <div class="partner">
    <div class="partner_title">应用表盘开发合作伙伴</div>
    <div class="partner_content">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_1.png"
        alt="partner_img1"
        style="width: 220px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_2.png"
        alt="partner_img1"
        style="width: 240px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_3.png"
        alt="partner_img1"
        style="width: 200px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_4.png"
        alt="partner_img1"
        style="width: 192px; height: 90px"
      />
    </div>
    <div class="partner_content" style="margin-top: 32px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_5.png"
        alt="partner_img1"
        style="width: 260px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_14.png"
        alt="partner_img1"
        style="width: 120px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_6.png"
        alt="partner_img1"
        style="width: 226px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_7.png"
        alt="partner_img1"
        style="width: 234px; height: 90px"
      />
    </div>
    <div class="partner_title">手表整机伙伴</div>
    <div class="partner_content">
      <!-- <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_8.png"
        alt="partner_img1"
        style="width: 144px; height: 130px"
      /> -->
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_9.png"
        alt="partner_img1"
        style="width: 146px; height: 130px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_10.png"
        alt="partner_img1"
        style="width: 242px; height: 130px"
      />
    </div>
    <div class="partner_content" style="margin-top: 32px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_11.png"
        alt="partner_img1"
        style="width: 292px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_12.png"
        alt="partner_img1"
        style="width: 232px; height: 90px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_13.png"
        alt="partner_img1"
        style="width: 232px; height: 90px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePartner",
};
</script>

<style scoped>
.partner {
  padding-bottom: 128px;
}
.partner_title {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 36px;
  color: #1f2937;
  text-align: center;
  padding-top: 240px;
  margin-bottom: 48px;
}
.partner_content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.partner_logo {
  margin: 0 9px;
}
</style>

